import React from "react";
import "../style.css";

const CardProject = React.memo(({ titel, rolle, image, link, type }) => (
  <div className="thumbnail">
    <div className="body">
      <img src={image} className="image" alt={titel} />
      {type === 'video' && (
        <div className="overlay">
          <a href={link} target="_blank" rel="noopener noreferrer" className="overlay-text h3">
            {titel}
          </a>
        </div>
      )}
    </div>
    <div className="head">
      <div className="h5">
        {titel}
      </div>
      <div className="bodycopy">
        {rolle}
      </div>
    </div>
  </div>
));

export default CardProject;
